//
//
//
// TODO combine with identical type: Alternative
//
//
//
export type MapRouteName =
  | "existing"
  | "NB_Only"
  | "SB_Only"
  | "Converging_Diverging"
  | "Converging_Diverging_Short";

export const MAP_ROUTE_NAMES: MapRouteName[] = [
  "existing",
  "NB_Only",
  "SB_Only",
  "Converging_Diverging",
  "Converging_Diverging_Short",
];

export type TravelTimes = {
  [key in MapRouteName]?: number;
};

export type RouteState = Record<`selected${MapRouteName}`, boolean>;

export const getSelectedRoutes = (routeState: RouteState): MapRouteName[] => {
  return MAP_ROUTE_NAMES.filter(
    (routeName) => routeState[`selected${routeName}`]
  );
};

export const isMobile = window.innerWidth < 768;
